<div
  #dietFormModal
  class="modal fade modal-xl"
  id="dietFormModal"
  tabindex="-1"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-labelledby="dietFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header w-100 d-flex justify-content-between">
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="editing">
          Edición de una dieta
        </h1>
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="!editing">
          Creación de una dieta
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="dietForm" (ngSubmit)="onSubmit()">
          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="text"
              [ngClass]="{ 'is-invalid': name.invalid && name.touched }"
              placeholder="Título"
              formControlName="name"
            />

            <label for="">Título</label>

            <div *ngIf="name.invalid && name.touched" class="text-danger">
              Ingrese un nombre.
            </div>
          </div>

          <div class="input-group">
            <div class="form-floating mb-3">
              <textarea
                class="form-control"
                type="text"
                [ngClass]="{
                  'is-invalid': description.invalid && description.touched
                }"
                placeholder="Descripción"
                formControlName="description"
                style="height: 250px"
              ></textarea>

              <label for="">Descripción</label>
            </div>
          </div>
          <div
            *ngIf="description.invalid && description.touched"
            class="text-danger"
          >
            Ingrese una descripción
          </div>

          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="number"
              [ngClass]="{
                'is-invalid': totalWeeks.invalid && totalWeeks.touched
              }"
              placeholder="Título"
              formControlName="totalWeeks"
            />

            <label for="">Semanas</label>

            <div
              *ngIf="totalWeeks.invalid && totalWeeks.touched"
              class="text-danger"
            >
              Ingrese una cantidad se semanas. Por ej. 6
            </div>
          </div>

          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="number"
              [ngClass]="{
                'is-invalid': water.invalid && water.touched
              }"
              placeholder="Título"
              formControlName="water"
            />

            <label for="">Cantidad de agua (Litros)</label>
          </div>

          <div class="mt-3">
            <span>Periodo de los permitidos</span>
            <select
              class="form-select form-select mb-1"
              aria-label="Small select example"
              formControlName="periodCheatMeals"
            >
              <option [value]="7">Una semana</option>

              <option [value]="28">Un mes</option>
            </select>
          </div>

          <div class="mt-3">
            <span>Permitidos</span>
            <select
              class="form-select form-select mb-1"
              aria-label="Small select example"
              formControlName="allowCheatMeals"
            >
              <option selected [value]="null">Cantidad de permitidos</option>
              <option [value]="i" *ngFor="let i of numbers">
                {{ i }}
              </option>
            </select>
          </div>

          <div class="mt-3">
            <label class="form-label">Días de la semana</label>
            <div
              class="border rounded p-2"
              [ngClass]="{
                'border-danger': daysOfWeek.invalid && daysOfWeek.touched
              }"
            >
              <div class="form-check" *ngFor="let day of availableDaysOfWeek">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [id]="day.value"
                  [value]="day.value"
                  [checked]="isDaySelected(day.value)"
                  (change)="onDayChange($event, day.value)"
                />
                <label class="form-check-label" [for]="day.value">
                  {{ day.label }}
                </label>
              </div>
            </div>
            <div
              *ngIf="daysOfWeek.invalid && daysOfWeek.touched"
              class="text-danger"
            >
              Seleccione al menos un día de la semana.
            </div>
          </div>

          <button
            [disabled]="dietForm.invalid"
            class="col-12 mt-3 d-grid btn-custom"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span *ngIf="editing">Editar</span>
            <span *ngIf="!editing">Crear</span>
          </button>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
